const getTagName = (element: Element) => element.tagName.toLowerCase()

export const getChildElements = (
  element: Element,
  tagName: string
): Element[] => {
  const normalizedTagName = tagName.toLowerCase()
  return Array.from(element.children).filter(
    (child) => getTagName(child) === normalizedTagName
  )
}

export const getFirstChildElement = (
  element: Element | null,
  tagNames: string[]
): Element | null => {
  if (!element) {
    return null
  }

  for (let index = 0; index < tagNames.length; index += 1) {
    const tagName = tagNames[index].toLowerCase()
    const child = getChildElements(element, tagName)[0]
    if (child) {
      return child
    }
  }

  return null
}

const getTextValue = (element: Element | null): string =>
  element?.textContent?.trim() || ''

export const getOptionalChildText = (
  element: Element | null,
  tagNames: string[]
): string | null => {
  const value = getTextValue(getFirstChildElement(element, tagNames))

  if (!value || value.toLowerCase() === 'null') {
    return null
  }

  return value
}

export const parseXmlDocument = (payload: string): Document => {
  return new DOMParser().parseFromString(payload, 'application/xml')
}
